import { createFileRoute } from '@tanstack/react-router';
import { CreatorsLandingPage } from '@/features/creators/landing/creators-landing-page';
import { loadViewer } from '@/features/creators/landing/load-viewer';
import { seo } from '@/utils/seo';

// /ixi-finance/creators — public ixigo Creators landing page. SSR'd and
// indexable. Lives under /ixi-finance so it needs no edge-routing change. The
// loader works out on the server whether the visitor is signed in and a
// creator, so the right buttons are in the HTML; signed out (and crawlers) get
// the public page.
export const Route = createFileRoute('/ixi-finance/creators')({
	head: () => ({
		meta: [
			...seo({
				title: 'ixigo Creators — earn on every trip your audience books',
				description:
					'Join ixigo Creators. Share your code with your audience and earn on every flight and hotel they book.',
			}),
			// Override the root route's `noindex,nofollow` — public marketing page.
			{ name: 'robots', content: 'index, follow' },
		],
	}),
	loader: () => loadViewer(),
	component: CreatorsLandingRoute,
	ssr: true,
});

function CreatorsLandingRoute() {
	return <CreatorsLandingPage viewer={Route.useLoaderData()} />;
}
